
import React from "react";

const BenefitsSection: React.FC = () => {
  return (
    <section className="section-spacing bg-white" id="benefits">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Walk & Talk Coaching
          </span>
          <h2 className="animate-fade-in" style={{ animationDelay: '100ms' }}>
            Warum Coaching in der Natur so wirksam ist
          </h2>
          <p className="mt-6 text-joerg-600 animate-fade-in" style={{ animationDelay: '200ms' }}>
            Bewegung, frische Luft und ein weiter Blick – manchmal braucht es nur einen anderen Rahmen, damit sich die richtigen Gedanken einstellen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-joerg-50 p-8 rounded-2xl shadow-soft animate-fade-in">
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-6 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-brain"><path d="M9.5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"/><path d="M14.5 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"/><path d="M21 7.6c0 1.8-.37 2.4-1.5 2.4-1.38 0-2-1.1-2-3.3 0-2.3.7-3.4-2-3.4-1 0-1.5.7-1.5 2.2Z"/><path d="M3 7.6c0 1.8.37 2.4 1.5 2.4 1.38 0 2-1.1 2-3.3 0-2.3-.7-3.4-2-3.4-1 0-1.5.7-1.5 2.2Z"/><path d="M9.5 2C8 2 7 3 7 6.5 7 10 8 12 9.5 12c1 0 1.5-1 1.5-3.5S10.5 2 9.5 2Z"/><path d="M14.5 2c1.5 0 2.5 1 2.5 4.5 0 3.5-1 5.5-2.5 5.5-1 0-1.5-1-1.5-3.5S13.5 2 14.5 2Z"/><path d="M15 12c0 3.5 1 4 2 4 1.5 0 2-1 2-4 0-3.5-1-5-2-5-.5 0-2 0-2 5Z"/><path d="M9 12c0 3.5-1 4-2 4-1.5 0-2-1-2-4 0-3.5 1-5 2-5 .5 0 2 0 2 5Z"/><path d="M12 22v-7"/><path d="M10 16.5V9"/><path d="M14 16.5V9"/><path d="M16 22c0-1.5-.5-3-4-3s-4 1.5-4 3"/></svg>
            </div>
            
            <h3 className="text-xl font-semibold text-center">Neue Denkwege</h3>
            
            <p className="mt-4 text-joerg-600">
              Bewegung in der Natur öffnet den Zugang zu Gedanken, die im Sitzen verborgen bleiben. Ein Wechsel des Raums verändert oft auch die Perspektive.
            </p>
          </div>
          
          <div className="bg-joerg-50 p-8 rounded-2xl shadow-soft animate-fade-in" style={{ animationDelay: '150ms' }}>
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-6 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mountains"><path d="m8 3 4 8 5-5 5 15H2L8 3z"/></svg>
            </div>
            
            <h3 className="text-xl font-semibold text-center">Perspektivwechsel</h3>
            
            <p className="mt-4 text-joerg-600">
              Die Weite des Rothsees schafft Abstand zum Alltag. Was im Büro festgefahren scheint, zeigt sich hier oft von einer ganz anderen Seite.
            </p>
          </div>
          
          <div className="bg-joerg-50 p-8 rounded-2xl shadow-soft animate-fade-in" style={{ animationDelay: '300ms' }}>
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-6 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-sparkles"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.235 1.235L3 12l5.865 1.965a2 2 0 0 1 1.235 1.235L12 21l1.9-5.8a2 2 0 0 1 1.235-1.235L21 12l-5.865-1.965a2 2 0 0 1-1.235-1.235L12 3Z"/></svg>
            </div>
            
            <h3 className="text-xl font-semibold text-center">Innere Ruhe</h3>
            
            <p className="mt-4 text-joerg-600">
              Die Natur schafft eine Atmosphäre, in der sich Anspannung löst. In dieser Ruhe werden tiefere Erkenntnisse möglich – ganz ohne Druck.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
